module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "modal-Ref",
    class: _vm.modalExtraClass,
    attrs: {
      "title": _vm.modalTitle,
      "hide-footer": "",
      "size": _vm.modalSize
    }
  }, [_vm._l((_vm.fields), function(field, index) {
    return _c('b-row', {
      key: index,
      staticClass: "mb-2"
    }, [_c('b-col', {
      attrs: {
        "md": "3"
      }
    }, [_c('label', [_vm._v(_vm._s(field.label) + " "), (field.required) ? _c('span', {
      staticClass: "text-danger"
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (field.fieldType === 'input') ? _c('b-form-input', {
      attrs: {
        "disabled": field.disabled,
        "placeholder": field.placeholder || '',
        "size": "sm"
      },
      model: {
        value: (_vm.formModel[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, field.key, $$v)
        },
        expression: "formModel[field.key]"
      }
    }) : _vm._e(), _vm._v(" "), (field.fieldType === 'textarea') ? _c('b-form-textarea', {
      attrs: {
        "rows": field.rows || 3,
        "disabled": field.disabled,
        "placeholder": field.placeholder || ''
      },
      model: {
        value: (_vm.formModel[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, field.key, $$v)
        },
        expression: "formModel[field.key]"
      }
    }) : _vm._e(), _vm._v(" "), (field.fieldType === 'datepicker') ? _c('b-form-datepicker', {
      attrs: {
        "disabled": field.disabled,
        "placeholder": field.placeholder || 'Select date'
      },
      model: {
        value: (_vm.formModel[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, field.key, $$v)
        },
        expression: "formModel[field.key]"
      }
    }) : _vm._e(), _vm._v(" "), (field.fieldType === 'single-select') ? _c('model-list-select', {
      attrs: {
        "disabled": field.disabled,
        "list": _vm.$store.getters[field.storeGetter],
        "option-value": field.optionValue,
        "option-text": field.optionText,
        "placeholder": field.placeholder || 'Select'
      },
      model: {
        value: (_vm.formModel[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, field.key, $$v)
        },
        expression: "formModel[field.key]"
      }
    }) : _vm._e(), _vm._v(" "), (field.fieldType === 'multi-select') ? _c('multi-select', {
      attrs: {
        "disabled": field.disabled,
        "options": _vm.$store.getters[field.storeGetter],
        "placeholder": field.placeholder || 'Select multiple',
        "multiple": true
      },
      model: {
        value: (_vm.formModel[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, field.key, $$v)
        },
        expression: "formModel[field.key]"
      }
    }) : _vm._e(), _vm._v(" "), (field.fieldType === 'radio-group') ? _c('b-form-radio-group', {
      staticClass: "mt-2",
      attrs: {
        "options": _vm.$store.getters[field.optionList],
        "value-field": field.valueField,
        "text-field": field.textField,
        "disabled-field": field.disabledField
      },
      model: {
        value: (_vm.formModel[field.key]),
        callback: function($$v) {
          _vm.$set(_vm.formModel, field.key, $$v)
        },
        expression: "formModel[field.key]"
      }
    }) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "text-center my-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.$emit('save', _vm.formModel)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideDynamicModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-646f1770","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/DynamicModal.vue
// module id = 2689
// module chunks = 0